import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { useInView } from "framer-motion";
import styles from "./VideosRowEn.module.css";
import TopTitleRow from "../TopTitleRow/TopTitleRow";
import LazyLoad from "react-lazy-load";
import VideosThumbnail from "../VideosThumbnail/VideosThumbnail";
import { slugGenerator } from "../../../lib/slugGenerator";
import Link from "next/link";

const allNewsLink = "/en/videos/";

const VideosRowEn = ({ data, title = undefined }) => {
  const viewRef = useRef();
  const isNewThumInView = useInView(viewRef);

  const [isStart, setIsStart] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const ref = useRef();
  const slideright = () => {
    ref.current.scrollBy({
      top: 0,
      left: +400,
      behavior: "smooth",
    });
  };
  const slideleft = () => {
    ref.current.scrollBy({
      top: 0,
      left: -400,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    try {
      let scrolledElement = document.getElementById("videosRowWrapper");
      scrolledElement.addEventListener("scroll", (event) => {
        if (scrolledElement.scrollLeft === 0) {
          setIsStart(true);
        } else {
          setIsStart(false);
        }
        if (
          scrolledElement.offsetWidth -
            (scrolledElement.scrollLeft + scrolledElement.scrollWidth) >
          -1
        ) {
          setIsEnd(true);
        } else {
          setIsEnd(false);
        }
      });
    } catch (error) {}
  });
  return (
    <div className={cx(styles.rowsContainer)}>
      <div
        style={{
          transform: isNewThumInView ? "translateY(5px)" : "translateY(-100px)",
          opacity: isNewThumInView ? 1 : 0,
          transition: "all ease 1400ms",
        }}
        className="d-flex"
      >
        <TopTitleRow title={title ? title : "Latest videos"} />
      </div>
      <div
        className={cx(
          styles.contentStyles,
          "d-inline-flex",
          "align-items-start",
          "overflow-auto",
          "position-relative"
        )}
      >
        <div ref={viewRef}></div>
        <div
          id="videosRowWrapper"
          ref={ref}
          className="d-flex align-items-start overflow-auto py-3"
        >
          {data?.results?.map((item, index) => (
            <div key={item.id}>
              <LazyLoad offset={200}>
                <div className={cx(styles.itemCotainerHelpreStyles)}>
                  <VideosThumbnail
                    viewRef={viewRef}
                    index={index}
                    id={item?.id}
                    key={item.id}
                    img={item?.thumbnail_img}
                    imgAlt={item?.title}
                    title={item?.title}
                    cat={item?.category?.title}
                    date={item?.date_published}
                    dark={true}
                    slug={`vod-${item.id}/${slugGenerator(item?.title)}`}
                    duration={item?.duration}
                  />
                </div>
              </LazyLoad>
            </div>
          ))}
          <div
            className={cx(
              styles.allNewsBtn,
              "d-flex",
              "align-items-center",
              "justify-content-center"
            )}
          >
            <button
              className={cx(
                styles.showAllNewsBtn,
                "d-flex",
                "align-items-center",
                "justify-content-center"
              )}
              aria-label="videosReadMoreBtn"
            >
              <Link
                style={{
                  transform: "translateY(3px)",
                }}
                aria-label="all news"
                href={allNewsLink}
              >
                View all videos
              </Link>
              <svg
                style={{
                  transform: "rotate(180deg)",
                }}
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.58583 1L1.00429 6.4632L5.58594 12"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 6.46484L12 6.46484"
                  stroke="white"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div className={cx(styles.newsBottomController, "position-absolute")}>
          <div
            style={{ gap: "15px" }}
            className="d-flex align-items-center justify-content-start"
          >
            <button
              style={{ transform: "rotate(180deg)" }}
              onClick={slideleft}
              className={cx(
                styles.sliderControllerBtn,
                isStart && styles.sliderControllerBtnDiactive,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "p-0"
              )}
              aria-label="scroll to left"
            >
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="26.5"
                  y="0.5"
                  width="26"
                  height="26"
                  rx="13"
                  transform="rotate(90 26.5 0.5)"
                  stroke="#1F3AE1"
                />
                <path
                  d="M14.4142 19L18.9957 13.5368L14.4141 8"
                  stroke="#1F3AE1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 13.5352L8 13.5352"
                  stroke="#1F3AE1"
                  strokeLinecap="round"
                />
              </svg>
            </button>
            <button
              onClick={slideright}
              className={cx(
                styles.sliderControllerBtn,
                isEnd && styles.sliderControllerBtnDiactive,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "p-0"
              )}
              aria-label="scroll to right"
            >
              <svg
                width="27"
                height="27"
                viewBox="0 0 27 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="26.5"
                  y="0.5"
                  width="26"
                  height="26"
                  rx="13"
                  transform="rotate(90 26.5 0.5)"
                  stroke="#1F3AE1"
                />
                <path
                  d="M14.4142 19L18.9957 13.5368L14.4141 8"
                  stroke="#1F3AE1"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 13.5352L8 13.5352"
                  stroke="#1F3AE1"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VideosRowEn;
